// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__iAv8L","validationTips":"StatementDescriptor_validationTips__h1_ZE"};